/* eslint-disable @typescript-eslint/no-use-before-define */
/**
 *
 * Select
 *
 */

import React from 'react';
import { Select as CustomSelect } from 'antd';
import './style.less';

// eslint-disable-next-line no-unused-vars
const { Option } = CustomSelect as any;
const SelectOption = Option;
// import PropTypes from 'prop-types';
// import styled from 'styled-components';

function Select({
  uniqueKey,
  displayKey,
  type = '',
  options,
  selected,
  children,
  ...rest
}: any): any {
  return (
    <CustomSelect mode={type} {...rest} style={{ height: '100%' }}>
      {children}
    </CustomSelect>
  );
}

export default Select;
export { SelectOption };
